export default __webpack_public_path__ + "static/media/image.schoolx.0a0723da.png";